export default __webpack_public_path__ + "static/media/J744MANA1.131359f2.pdf";